<div mat-dialog-content>
	<p>{{ message }}</p>
</div>
<div mat-dialog-actions fxLayout fxLayoutAlign="end">
	<button mat-button color="primary" mat-dialog-close>
		Close
	</button>
</div>
